import Step from 'models/steps/Step';
import ResellerJourney from 'aa/vue/components/reseller/ResellerJourney';
import { PAGE_TYPES } from 'aa/vue/constants/aaTrackingConstants';

export default class IosSignupStep extends Step {
    path = '/account/signup/payment/ios-signup/';
    name = 'ios_signup_journey';
    component = ResellerJourney;
    requireAuth = true;
    props = {
        type: 'signup',
    };
    enterRoute(to, from, next) {
        super.enterRoute(to, from, next);
    }
    /**
     * @param to
     * @returns {{path: *, name: *}}
     */
    getTrackingArgs(to) {
        let args = super.getTrackingArgs(to);
        args.pageType = PAGE_TYPES.SIGNUP_COMPLETE;
        args.pageUrl = window.location.href;
        args.userStatus = this._store.getters['user/trackingUserStatus'];
        args.userType = this._store.state.user.svod.status;
        return args;
    }
}
